import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=6d5b8f30&scoped=true"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=6d5b8f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b8f30",
  null
  
)

export default component.exports